import React from 'react';
import { motion } from 'framer-motion';
import styles from '@/styles/components/PageWrapper.module.css';

const PageWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <motion.div
    initial={{ opacity: 0, y: 20 }}
    animate={{ opacity: 1, y: 0 }}
    exit={{ opacity: 0, y: -20 }}
    transition={{ duration: 0.3, ease: 'easeInOut' }}
    className={styles.pageWrapper}
  >
    {children}
  </motion.div>
);

export default PageWrapper; 